export type RouteEntry = {
  path: string;
  label?: string;
};

const internalRegistry: RouteEntry[] = [];

declare global {
  interface Window {
    __ROUTES__?: RouteEntry[];
  }
}

const ensureGlobalRegistry = (): RouteEntry[] => {
  if (typeof window !== 'undefined') {
    if (!Array.isArray(window.__ROUTES__)) {
      window.__ROUTES__ = internalRegistry.slice();
    }
    return window.__ROUTES__ as RouteEntry[];
  }

  return internalRegistry;
};

const appendDeduped = (target: RouteEntry[], routes: RouteEntry[]) => {
  routes.forEach((route) => {
    if (!route || !route.path) return;
    if (!target.some((existing) => existing.path === route.path)) {
      target.push({ path: route.path, label: route.label });
    }
  });
};

export const registerRoutes = (routes: RouteEntry[]) => {
  if (!Array.isArray(routes) || routes.length === 0) return;

  const globalRegistry = ensureGlobalRegistry();
  appendDeduped(globalRegistry, routes);

  if (globalRegistry !== internalRegistry) {
    appendDeduped(internalRegistry, routes);
  }
};

export const getRoutes = (): RouteEntry[] => {
  const registry = ensureGlobalRegistry();
  return registry.slice();
};
